
import { defineComponent, ref } from "vue";
import { location } from "@/utils/default-data";
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  setup(props, context) {
    const email = ref("");
    const password = ref("");
    const register = ref(false);

    const close = () => {
      context.emit("close");
    };

    const onClickLogin = () => {
      console.info("OnClickLogin");
    };

    return {
      email,
      password,
      register,
      close,
      onClickLogin,
      location,
    };
  },
});
